import axiosClient from "utils/api";
const URI = "/admin/review";

export const getReview = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get Reviews:", error);
    throw error;
  }
};

export const deleteReview = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
      data: rest
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Delete Review:", error);
    throw error;
  }
};

export const addReview = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Add Review:", error);
    throw error;
  }
};

export const updateReview = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get Reviews:", error);
    throw error;
  }
};

